"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _image = require("@site/pattern-library-core/image");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _cardItem = _interopRequireDefault(require("./card-item.js"));
var _scrollIndicator = _interopRequireDefault(require("../../product-merchandising/plan-box-section-subscription/scroll-indicator.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/lazy-video/index.js"));
var _playButton = _interopRequireDefault(require("../../media-components/video-lightbox/play-button.js"));
var _index3 = _interopRequireDefault(require("../../../experiments/animation/motion-move/index.js"));
var _index4 = _interopRequireDefault(require("../../media-components/video-lightbox/index.js"));
var _functions = require("./functions.js");
var _index5 = _interopRequireDefault(require("../../../elements/buttons/play-button/index.js"));
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const SectionWrapper = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionWrapper",
  class: "pl-s1vybojm"
});
const Container = /*#__PURE__*/(0, _react2.styled)(_index3.default)({
  name: "Container",
  class: "pl-cfp8yop"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hua2czk"
});
const CarouselContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselContainer",
  class: "pl-c10ypmdw"
});
const CardGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardGroup",
  class: "pl-c74p6c3"
});
const ImageGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageGroup",
  class: "pl-i1fv83zu"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-i12w4599"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-vya9n3s"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_index2.default)({
  name: "Video",
  class: "pl-vmiew4i"
});
const Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-c1dy5w00"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-b1347ubx"
});

/**
 * DesktopVideoCard Component.
 * @param {Object} props React props
 * @param {Number} props.activeTab Active Tab Index
 * @param {Number} props.idx Current Tab Index
 * @param {Object} props.videoSource Video Source
 * @param {Boolean} props.play Play State
 * @param {Function} props.handleChange Handle Change Function
 * @param {String} props.preload Preload Value
 * @returns {React.ReactElement} DesktopVideoCard Component
 * @public
 */

function DesktopVideoCard({
  activeTab,
  idx,
  videoSource,
  play,
  handleChange,
  preload
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(VideoContainer, {
    "data-cy": "inline-video",
    className: activeTab === idx ? 'active' : ''
  }, /*#__PURE__*/_react.default.createElement(Video, {
    videoSource: videoSource,
    preload: preload,
    loop: true,
    autoPlay: true,
    pause: play
  })), /*#__PURE__*/_react.default.createElement(Controls, {
    "data-cy": "inline-video-control",
    className: activeTab === idx ? 'active inline-control' : 'inline-control'
  }, /*#__PURE__*/_react.default.createElement(_index5.default, {
    dataCy: "inline-video-play-button",
    handlePlay: handleChange,
    pause: !play,
    size: "small",
    invert: true
  })));
}
DesktopVideoCard.propTypes = {
  activeTab: _propTypes.default.number,
  idx: _propTypes.default.number,
  videoSource: _propTypes.default.object,
  play: _propTypes.default.bool,
  handleChange: _propTypes.default.func,
  preload: _propTypes.default.oneOf(['auto', 'metadata', 'none'])
};
function DesktopImageCard({
  activeTab,
  idx,
  item,
  handlePlayButtonClick
}) {
  const {
    landscape,
    lightboxUrl,
    youTubeId
  } = item;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    className: activeTab === idx ? 'active' : ''
  }, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultAltText: landscape?.altText,
    dataCy: "image-container-landscape"
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: landscape?.url,
    media: `${_patternLibraryUtils.device.tabletLg}`
  }))), (lightboxUrl || youTubeId) && /*#__PURE__*/_react.default.createElement(Controls, {
    "data-cy": "lightbox-video-control",
    className: activeTab === idx ? 'active lightbox-control' : 'lightbox-control'
  }, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "lightbox-video-play-button",
    size: "large",
    handlePlay: handlePlayButtonClick
  })));
}
DesktopImageCard.propTypes = {
  activeTab: _propTypes.default.number,
  idx: _propTypes.default.number,
  item: _propTypes.default.object,
  handlePlayButtonClick: _propTypes.default.func
};

/**
 * ProductFeaturesSection Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking name of the component
 * @param {String} props.verticalMargin Vertical Outer Spacing value
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @param {String} props.partial Partial Theme
 * @param {Array} props.cards Array of Tab Cards
 * @param {String} props.headlineTag Headline Tag of all Cards
 * @param {String} props.headlineSize Headline Size of all Cards
 * @param {Number} props.headlineLineLength Headline Line Length of all Cards
 * @param {Object} props.mainCta Main Button
 * @param {Object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} ProductFeaturesSection Component
 * @public
 */

function ProductFeaturesSection({
  _name,
  verticalPadding,
  verticalMargin,
  cards,
  mainCta,
  headlineTag,
  headlineSize,
  headlineLineLength,
  cardsHeadlineTag,
  cardsHeadlineSize,
  cardsHeadlineLineLength,
  priceLockup,
  partial = 'light1',
  ...rest
}) {
  const target = (0, _react.useRef)();
  const [activeTab, setActiveTab] = (0, _react.useState)(0);
  const [play, setPlay] = (0, _react.useState)(false);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const [currentLightboxUrl, setCurrentLightboxUrl] = (0, _react.useState)(null);
  const [currentYoutubeId, setCurrentYoutubeId] = (0, _react.useState)(null);
  const isRTL = (0, _patternLibraryUtils.useIsRTL)();
  const handleTabMouseOver = index => {
    setActiveTab(index);
  };
  const handlers = {
    lightboxUrl: setCurrentLightboxUrl,
    youTubeId: setCurrentYoutubeId
  };
  const handlePlayButtonClick = item => {
    for (const [key, handler] of Object.entries(handlers)) {
      if (item[key]) {
        handler(item[key]);
        setShowModal(true);
        return;
      }
    }
  };
  const handleChange = () => setPlay(prevCheck => !prevCheck);
  (0, _functions.useScrollHandler)(target, isRTL, setActiveTab);
  return /*#__PURE__*/_react.default.createElement(SectionWrapper, {
    _name: _name,
    dataCy: "product-features-section",
    padding: "none",
    partial: partial,
    verticalPadding: verticalPadding,
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(Container, {
    mode: "fluid",
    intensity: "300",
    variant: "moveUpFixed",
    triggerOnce: true,
    staggerChildren: true
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    headlineTag: headlineTag,
    headlineSize: headlineSize,
    headlineLineLength: headlineLineLength,
    priceLockup: priceLockup
  }, rest))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CarouselContainer, {
    ref: target,
    "data-cy": "carousel-container"
  }, width >= _patternLibraryUtils.size.tabletLg && /*#__PURE__*/_react.default.createElement(ImageGroup, {
    "data-cy": "image-group"
  }, cards && cards.slice(0, 3).map((item, idx) => {
    const videoSource = {
      fallback: item.thumbnailDesktop,
      laptop: item.introUrlLaptop,
      laptopWebm: item.introUrlLaptopWebm
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: idx
    }, item.introUrlLaptop && /*#__PURE__*/_react.default.createElement(DesktopVideoCard, {
      activeTab,
      idx,
      videoSource,
      preload: item?.preload,
      play,
      handleChange: () => handleChange(false)
    }), item.landscape && /*#__PURE__*/_react.default.createElement(DesktopImageCard, {
      activeTab,
      idx,
      item,
      handlePlayButtonClick: () => handlePlayButtonClick(item)
    }));
  })), /*#__PURE__*/_react.default.createElement(CardGroup, {
    "data-cy": "card-group"
  }, cards?.slice(0, 3).map((item, idx) => {
    const videoSourceMobile = {
      fallback: item.thumbnailMobile,
      base: item.introUrl,
      baseWebm: item.introUrlWebm
    };
    return /*#__PURE__*/_react.default.createElement(_cardItem.default, (0, _extends2.default)({
      key: idx,
      active: activeTab === idx,
      handleAction: () => handleTabMouseOver(idx),
      videoSource: videoSourceMobile,
      lightboxHandlePlay: () => handlePlayButtonClick(item),
      headlineTag: cardsHeadlineTag,
      headlineSize: cardsHeadlineSize,
      headlineLineLength: cardsHeadlineLineLength,
      preload: item?.preload,
      priceLockup: item?.priceLockup,
      partial: partial
    }, item));
  })))), target && /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    "data-cy": "main-cta"
  }, /*#__PURE__*/_react.default.createElement(_scrollIndicator.default, {
    elementArr: cards?.length,
    element: target
  }), mainCta && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: [mainCta]
  }))), (currentLightboxUrl || currentYoutubeId) && /*#__PURE__*/_react.default.createElement(_index4.default, (0, _extends2.default)({}, rest, {
    dataCy: "lightbox-video-player",
    dataCyYoutubePlayer: "lightbox-video-player",
    lightboxUrl: currentLightboxUrl,
    youTubeId: currentYoutubeId,
    showModal: showModal,
    handleClose: () => {
      setShowModal(false);
      setCurrentLightboxUrl(null);
      setCurrentYoutubeId(null);
    },
    ariaLabelCloseButton: "close-lightbox"
  })));
}
var _default = exports.default = ProductFeaturesSection;
ProductFeaturesSection.propTypes = {
  _name: _propTypes.default.string,
  cards: _propTypes.default.array,
  mainCta: _propTypes.default.object,
  headlineTag: _propTypes.default.string,
  headlineSize: _propTypes.default.string,
  headlineLineLength: _propTypes.default.number,
  priceLockup: _propTypes.default.object,
  partial: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};